import React, { useEffect, useState } from "react";
import classes from "../../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_PURCHASE_OTP_CONFRIMATION_,
  ROUTE_Purchase_One_Time,
} from "../../Routes";
import { useSelector } from "react-redux";
import { selectBankName } from "../../Store/UserBankSlice";
import axios from "../../libs/axiosConfig";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { selectTransactionNumber } from "../../Store/TransactionNoSlice";
import { ToastContainer, toast } from "react-toastify";
import Toast from "../../Components/ToastMsg/Toast";

const Confirmation = () => {
  const Navigate = useNavigate();
  const bankName = useSelector(selectBankName);
  const location = useLocation();

  const { purchaseTypes } = location.state || {};
  console.log(purchaseTypes);
    // console.log(purchaseTypes?.amount);
  console.log(bankName);
  const updatedPortfolioData =
    useSelector((state) => state.updatedPortfolio.updatedPortfolioData) || {};
  console.log(updatedPortfolioData, "Data");
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const transactionNumber = useSelector(selectTransactionNumber);
  const panNumber = useSelector(selectPanNumber);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const userType = useSelector(
    (state) => state.portfolio.selectedPortfolioType
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  if (
    !Object.keys(updatedPortfolioData).length ||
    !purchaseTypes ||
    purchaseTypes.length === 0
  ) {
    return (
      <div className={classes.Null_Message_Container}>
        We are working on this 
        <button
          className={classes.Submit_button}
          onClick={() => Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN)}
        >
          Contact Dexterr Support Team
        </button>
      </div>
    );
  }
  const portfolioTypeKey =
    Object.keys(updatedPortfolioData.portfolio_type)[0] || "";
  const portfolioType = updatedPortfolioData.portfolio_type[portfolioTypeKey];
  console.log(portfolioType);

  const purchase_onetime =
    portfolioType.min_total_amount_fresh_purchase_onetime || " ";
  const purchase_systematic =
    portfolioType.min_total_amount_fresh_purchase_systematic || " ";

  console.log(purchase_onetime, purchase_systematic, "Data Collect");

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const formattedPurchaseOnetime = formatNumberWithCommas(
    purchase_onetime || ""
  );
  const formattedPurchaseSystematic = formatNumberWithCommas(
    purchase_systematic || ""
  );

  const HandleSubmit = async () => {
    try {
      if (!bankName.bankName) {
        console.log("Bank name is not present. Skipping API call.");
        return;
      }
      setApiCallsInProgress(apiCallsInProgress + 1);

      // Bank name is present, proceed with the API call
      const axiosConfig = {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "application/json",
          // RefreshToken: refreshToken
        },
      };

      const response = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          OtpVerification: {
            dexterr_transaction_no: transactionNumber,
            mobileNumber: phoneNumber,
            pan: panNumber,
            service: "purchase",
            job: "sendOtp",
          },
        },
        axiosConfig
      );

      console.log("API Response:", response.data);
      if (response.data.statusCode === 200) {
        Navigate(ROUTE_PURCHASE_OTP_CONFRIMATION_, {
          state: { UserMobileNumber: phoneNumber },
        });
        setApiCallsInProgress(apiCallsInProgress - 1);
      } else {
        toast.error(response.data.errorMessage);
        setApiCallsInProgress(apiCallsInProgress - 1);
      }
    } catch (error) {
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
          "Error"
      );
      console.error("Error occurred while making API call:", error);
      // .error("Failed to submit. Please try again later.");
    }
  };

  const HandleBack = () => {
    Navigate(ROUTE_Purchase_One_Time);
  };

  return (
    <div className={classes.Confirmation_Container}>
      <div className={classes.Purchase_Header}>
        <ArrowBackIosIcon className={classes.Back_btn} onClick={HandleBack} />
      </div>
      <div className={classes.Confirmation_Payment_Container}>
        <p className={classes.Confirmation_Heading_Text}>Confirmation</p>
        <div className={classes.Confirmation_Data_Container}>
          <div className={classes.Investing_Data_Container}>
            <div className={classes.Investing_Amount_Container1}>
              <span className={classes.ValueText1}>Investing</span>
              <p className={classes.Confirmation_Text_Container1}>
                <span className={classes.ValueText2}>
                  {purchaseTypes.map((purchaseType, index) => (
                    <span key={index}>
                      {index !== 0 && " + "}₹ {purchaseType.amount}
                    </span>
                  ))}{" "}
                </span>
                <span className={classes.ValueText3}>
                  {purchaseTypes.map((purchaseType, index) => (
                    <span key={index}>
                      {index !== 0 && " + "}
                      {purchaseType.type}
                    </span>
                  ))}{" "}
                </span>
              </p>
            </div>
            <p className={classes.Investing_Amount_Container2}>
              <span className={classes.ValueText1}>Investing in</span>
              <span className={classes.ValueText2}>{userType}</span>
            </p>
            <p className={classes.Investing_Amount_Container3}>
              <span className={classes.ValueText1}>Pay using</span>
              <span className={classes.ValueText2}>
                Net Banking - {bankName.bankName}
              </span>
            </p>
          </div>

          <button
            className={classes.Confirmation_PortFolio_Button}
            onClick={HandleSubmit}
          >
            Confirm and Review Portfolio
          </button>
        </div>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Confirmation;
